/**
 * TipIcon — Tip callout icon. Steel-blue background, white lightbulb glyph.
 *
 * Production SVG landed 2026-05-04 in /design/icons/callout-tip-lightbulb.svg.
 * Geometry preserved from the v10 mockup reference; structurally split into
 * primitives (bulb path + filament-base line + lower-screw line) and
 * accessibility-tagged (role="img" + aria-label).
 */

import IconCircle from "./IconCircle.jsx";

export default function TipIcon({ size = 38 }) {
  const stroke = "var(--ppr-color-background-surface)";
  return (
    <IconCircle size={size} bg="var(--ppr-color-accent-steel)">
      <svg
        width={size * 0.55}
        height={size * 0.55}
        viewBox="0 0 24 24"
        fill="none"
        role="img"
        aria-label="Tip"
      >
        {/* Bulb body */}
        <path
          d="M12 3 C 8 3 6 6 6 9 C 6 11 7 13 9 14 L 9 16 L 15 16 L 15 14 C 17 13 18 11 18 9 C 18 6 16 3 12 3 Z"
          stroke={stroke}
          strokeWidth="2"
          strokeLinejoin="round"
        />
        {/* Filament base bar */}
        <line x1="9" y1="18" x2="15" y2="18" stroke={stroke} strokeWidth="2" strokeLinecap="round" />
        {/* Lower screw line */}
        <line x1="10" y1="21" x2="14" y2="21" stroke={stroke} strokeWidth="2" strokeLinecap="round" />
      </svg>
    </IconCircle>
  );
}
